import { string } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { Box, Link, Text } from '@olist/united';

const UnqualifiedChangeButton = ({ to }) => {
  const { t } = useTranslation();

  return (
    <Box display="flex">
      <Link as={RouterLink} to={to} icon="arrow-left-outline">
        {t`change`}
      </Link>
      <Box mt={[5, 1]} mb={6} ml={2}>
        <Text color="textLight" mt={0} fontSize={0} display={['none', 'block']}>
          {t`selected an item by mistake?`}
        </Text>
        <Text color="textLight" fontSize={0} display={['none', 'block']}>
          {t`click to change.`}
        </Text>
      </Box>
    </Box>
  );
};

export default UnqualifiedChangeButton;

UnqualifiedChangeButton.propTypes = {
  to: string.isRequired,
};
